// extracted by mini-css-extract-plugin
module.exports = {"floatinglogo":"floatinglogo-module--floatinglogo--15rpr","whiteLogo":"floatinglogo-module--whiteLogo--nTe5D","colorLogo":"floatinglogo-module--colorLogo--3Ra8Q"};